import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import ImageIcon from "../shared/image_icon";
import UserImage from "../shared/user_image";
import { useQuery } from "@tanstack/react-query";
import { hasUnreadMessages, hasUnreadGroupsEvents } from "../../src/queries";
import { isTruthy } from "../../helpers/application";
import RedDot from "../shared/red_dot";
import useTranslation from "next-translate/useTranslation";

const MENU_PATHS = [
  { name: "calendar", path: "/" },
  { name: "search", path: "/search" },
  { name: "groups", path: "/groups" },
  { name: "chats", path: "/chat_rooms" },
];

const NavbarBottom = () => {
  const { data: session } = useSession();
  const router = useRouter();
  const { t } = useTranslation("common");

  const { data: hasUnreadMessagesResult } = useQuery(
    ["has_unread_messages", session?.user?.id],
    () => hasUnreadMessages(),
    {
      enabled: isTruthy(session?.user) && !hasUnreadMessagesResult,
    }
  );

  const { data: hasUnreadGroupsEventsResult } = useQuery(
    ["has_unread_groups_events", session?.user?.id],
    () => hasUnreadGroupsEvents(),
    {
      enabled: isTruthy(session?.user) && !hasUnreadGroupsEventsResult,
    }
  );

  return (
    <nav className="navbar fixed-bottom navbar-expand container">
      <ul className="navbar-nav w-100 p-0 m-0 mb-3 align-items-center">
        <div className="row w-100 justify-content-between">
          {MENU_PATHS.map((path) => (
            <div className="col-auto p-0" key={path.name}>
              <li className="nav-item position-relative">
                <a className="nav-link navbar-brand m-0 text-center" onClick={() => router.push(path.path)}>
                  <ImageIcon
                    name={router.pathname !== path.path ? `${path.name}` : `${path.name}-active`}
                    width={28}
                    height={28}
                  />
                  <div
                    style={{ fontSize: "11px", marginTop: "-4px" }}
                    className={`mb-0 ${router.pathname == path.path ? "text-accent1" : ""}`}
                  >
                    {t(`navbar_bottom.${path.name}`)}
                  </div>
                  {path.name === "chats" && hasUnreadMessagesResult?.has_unread_messages && <RedDot />}
                  {path.name === "groups" && hasUnreadGroupsEventsResult?.has_unread_groups_events && <RedDot />}
                </a>
              </li>
            </div>
          ))}

          <div className="col-auto p-0">
            <li className="nav-item">
              <a className="nav-link navbar-brand me-0" onClick={() => router.push(`/profile/${session?.user?.id}`)}>
                {session?.user && (
                  <div className="align-content-center justify-content-center">
                    <div className="mb-1 text-center">
                      <UserImage
                        width={22}
                        height={22}
                        name={session.user.first_name}
                        src={session.user.avatar_thumb}
                        borderColor={router.pathname === `/profile/[id]` ? "#38A8C0" : "#031228"}
                      />
                    </div>
                    <div
                      style={{ fontSize: "11px", marginLeft: "-5px", marginTop: "5px" }}
                      className={`${router.pathname === `/profile/[id]` ? "text-accent1" : ""}`}
                    >
                      <span> {t("navbar_bottom.profile")}</span>
                    </div>
                  </div>
                )}
              </a>
            </li>
          </div>
        </div>
      </ul>
    </nav>
  );
};

export default NavbarBottom;
